module.exports = __webpack_public_path__ + "f18e595f7ef211269383fc7f434a698c.png";